
$(".megamenu-parent-link:not(.no-children)").click(function (e) {
  e.preventDefault();
  var $parent = $(this).parents(".header-bottom-nav-item");
  var $list_parent = $parent.parents("ul");

  if ($(this).hasClass("active")) {
    megaMenuClose();
  } else {
    megaMenuClose();

    $parent.addClass("active");
    $("html").addClass("mega-menu--open");
    $list_parent.addClass("has-active");
  }
});

$(".megamenu-close-button").click(function (e) {
  e.preventDefault();
  megaMenuClose();
});

function megaMenuClose() {
  $("html").removeClass("mega-menu--open");
  var $activeItems = $(".header-bottom-nav-item.active");
  var $list_parent = $(".header-bottom-nav-ul");

  $list_parent.removeClass("has-active");
  $activeItems.removeClass("closing");
  $activeItems.removeClass("active");

  //dirty hack for accessibe to close the megamenu
  $activeItems.trigger("click");

  setTimeout(function () {}, 300);
}





$(".parent_has_submenu").click(function (e) {
  var $parent = $(this).parents(".fixed-nav-menu-item");
  e.preventDefault();
  if ($parent.hasClass("active")) {
    $parent.removeClass("active");
  } else {
    $("#fixed-menu").addClass("submenu-open");
    setTimeout(function () {
      $parent.addClass("active");
    }, 100);
    $(".header-content .toggle-menus").hide();
  }
});

function fixedNavSubMenuClose() {
  var $active_nav = $(".fixed-nav-menu-item.active");

  $active_nav.addClass("closing");
  setTimeout(function () {
    $("#fixed-menu").removeClass("submenu-open");
    $(".fixed-nav-menu-list").focus();
    $active_nav.removeClass("closing");
    $active_nav.removeClass("active");
    $(".header-content .toggle-menus").show();
  }, 800);
}

$(".js-fixed-nav-back").click(function (e) {
  console.log("helloasdas");
  fixedNavSubMenuClose();
});


//header logo video
$(document).ready(function () {
  const video = document.querySelector(".logo-video-container video");

  const videoContainerEl = document.querySelector(".logo-video-container");

  if (video) {
    video.addEventListener(
      "loadeddata",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplay",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplaythrough",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener("ended", function () {
      //console.log("video ended");
      //videoContainerEl.classList.remove("video-loaded");
    });

    playLogoVideo();

    video.removeAttribute("controls");
  }

  function playLogoVideo() {
    video.play();
    //console.log("play");
    setTimeout(function () {
      videoContainerEl.classList.add("video-loaded");
    }, 500);
  }

  $(".nav-menu.recent-additions").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=created-descending";

    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 3;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }
            },
            error: function () {
            _this.hide();
            },
        });
    });

    $(".nav-menu.best-sellers").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=best-selling";
    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 5;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }

            /*hide parent link if products == 0 
            if(json.products.length == 0){
                _this.parents('.header-bottom-nav-item').hide();
                _this.parents('.fixed-nav-menu-item').hide();
            }
            */
            },
            error: function () {
            _this.hide();
            },
        });
    });
});